<template>
  <el-dialog
    :title="!dataForm.id ? 'Add Nominee Director' : 'Edit Nominee Director'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="1000px"
    top="3vh"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-position="top">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Name" prop="fullName">
            <el-input v-model="dataForm.fullName" placeholder="Name" v-regexFilter="halfWidthRegex"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Country" prop="nationality">
            <el-select v-model="dataForm.nationality" placeholder="Select Country" class="wdb100" @change="onNationalityChange">
              <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="IdentificationType" prop="identificationType">
            <el-select v-model="dataForm.identificationType" placeholder="Select country first" class="wdb100">
              <el-option v-for="item in identificationTypeOptions" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="ID Number" prop="identificationNo">
            <el-input v-model="dataForm.identificationNo" placeholder="identificationNo" v-regexFilter="halfWidthRegex"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Email" prop="email">
            <el-input v-model="dataForm.email" placeholder="email" v-regexFilter="halfWidthRegex"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Mobile" prop="phone.code" :rules="[{ validator: validatePhone, trigger: 'submit' }]">
            <el-input v-model="dataForm.phone.code" class="input-with-select-xs" v-regexFilter="numOrPointRegex">
              <el-select v-model="dataForm.phone.prefix" slot="prepend">
                <el-option v-for="single in prefixOptions" :key="single.title" :value="single.value">
                  {{ single.value + " " + single.title }}
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Birth Date" prop="birthDate">
            <el-date-picker
              v-model="dataForm.birthDate"
              type="date"
              placeholder="Birth Date"
              value-format="yyyy-MM-dd"
              class="fluid-width"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Supplier" prop="supplierId">
            <el-select v-model="dataForm.supplierId" filterable clearable class="wdb100">
              <el-option v-for="item in supplierList" :key="`supplier-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 原 Address 字段：仅当不支持地址模块的国家时显示 -->
      <el-row v-if="!showAddressModules" :gutter="20">
        <el-col :span="24">
          <el-form-item label="Address" prop="residentialAddress">
            <el-input v-model="dataForm.residentialAddress" placeholder="Residential Address" v-regexFilter="halfWidthRegex"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 个人信息扩展字段（formerName / gender / occupation / race） -->
      <template v-if="showPersonalExtraFields">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Former Name" prop="formerName">
              <el-input v-model="dataForm.formerName" placeholder="Former Name" v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Gender" prop="gender">
              <el-select v-model="dataForm.gender" placeholder="Select Gender" class="wdb100">
                <el-option v-for="item in genderTypeList" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Occupation (e.g. Businessman, CEO, Senior Officer, etc.)" prop="occupation">
              <el-input v-model="dataForm.occupation" placeholder="Occupation" v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Race" prop="race">
              <el-select v-model="dataForm.race" placeholder="Select Race" class="wdb100">
                <el-option v-for="item in raceOptions" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <!-- 注册地址 + 服务地址模块：仅当支持地址模块的国家时显示 -->
      <template v-if="showAddressModules">
        <div class="mt10 address-section-header">
          <span class="address-section-title">Residential Address</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Line 1" prop="residentialAddressLine1">
              <el-input v-model="dataForm.residentialAddressLine1" placeholder="Address Line 1" v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Line 2" prop="residentialAddressLine2">
              <el-input v-model="dataForm.residentialAddressLine2" placeholder="Address Line 2" v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Line 3" prop="residentialAddressLine3">
              <el-input v-model="dataForm.residentialAddressLine3" placeholder="Address Line 3" v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="City" prop="residentialAddressCity">
              <el-input v-model="dataForm.residentialAddressCity" placeholder="City" v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="State" prop="residentialAddressState">
              <el-input v-model="dataForm.residentialAddressState" placeholder="State" v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Postal Code" prop="residentialAddressPostalCode">
              <el-input v-model="dataForm.residentialAddressPostalCode" placeholder="Postal Code" v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Country" prop="residentialAddressCountry">
              <el-select v-model="dataForm.residentialAddressCountry" placeholder="Select Country" class="wdb100">
                <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="mt10 address-section-header">
          <span class="address-section-title">Service Address</span>
          <el-form-item prop="serviceAddressType" class="same-address-checkbox">
            <el-checkbox v-model="isSameAsResidential">Same as Registered Address</el-checkbox>
          </el-form-item>
        </div>
        <!-- serviceAddressType === 2 (Other) 时显示详细地址字段；=== 1 (Same) 时隐藏 -->
        <template v-if="dataForm.serviceAddressType === 2">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Line 1" prop="serviceAddressLine1">
                <el-input v-model="dataForm.serviceAddressLine1" placeholder="Address Line 1" v-regexFilter="halfWidthRegex"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Line 2" prop="serviceAddressLine2">
                <el-input v-model="dataForm.serviceAddressLine2" placeholder="Address Line 2" v-regexFilter="halfWidthRegex"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Line 3" prop="serviceAddressLine3">
                <el-input v-model="dataForm.serviceAddressLine3" placeholder="Address Line 3" v-regexFilter="halfWidthRegex"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="City" prop="serviceAddressCity">
                <el-input v-model="dataForm.serviceAddressCity" placeholder="City" v-regexFilter="halfWidthRegex"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="State" prop="serviceAddressState">
                <el-input v-model="dataForm.serviceAddressState" placeholder="State" v-regexFilter="halfWidthRegex"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Postal Code" prop="serviceAddressPostalCode">
                <el-input v-model="dataForm.serviceAddressPostalCode" placeholder="Postal Code" v-regexFilter="halfWidthRegex"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Country" prop="serviceAddressCountry">
                <el-select v-model="dataForm.serviceAddressCountry" placeholder="Select Country" class="wdb100">
                  <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </template>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Status" prop="status">
            <el-radio-group v-model="dataForm.status">
              <el-radio :label="0">Disable</el-radio>
              <el-radio :label="1">Enable</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit()">Submit</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { validateFormLocation } from "@/utils";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters } from "vuex";
export default {
  mixins: [validatorMixin],
  props: {
    supplierList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        nationality: "",
        fullName: "",
        formerName: "",
        email: "",
        identificationType: "",
        identificationNo: "",
        residentialAddress: "",
        gender: "",
        occupation: "",
        race: "",
        residentialAddressLine1: "",
        residentialAddressLine2: "",
        residentialAddressLine3: "",
        residentialAddressCountry: "",
        residentialAddressCity: "",
        residentialAddressState: "",
        residentialAddressPostalCode: "",
        serviceAddressType: 2,
        serviceAddressLine1: "",
        serviceAddressLine2: "",
        serviceAddressLine3: "",
        serviceAddressCountry: "",
        serviceAddressCity: "",
        serviceAddressState: "",
        serviceAddressPostalCode: "",
        phone: {
          prefix: "",
          code: "",
        },
        birthDate: "",
        supplierId: null,
        status: 1,
      },
      dataRule: {
        fullName: [{ required: true, message: "please enter", trigger: "submit" }],
        nationality: [{ required: true, message: "please select", trigger: "submit" }],
        email: [{ type: "email", message: "please provide a valid email address", trigger: "submit" }],
        birthDate: [{ validator: this.validateComeAge, trigger: "submit" }],
        supplierId: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "prefixOptions", "genderTypeList"]),
    ...mapGetters("constant", ["byCountryFormatList"]),
    // 证件类型选项（根据国籍动态匹配，默认回退到 Singapore）
    identificationTypeOptions() {
      const MALAYSIA = "Malaysia";
      const SINGAPORE = "Singapore";
      const country = this.dataForm.nationality === MALAYSIA ? MALAYSIA : SINGAPORE;
      return this.byCountryFormatList("identificationTypeData", country);
    },
    // 是否显示个人信息扩展字段（formerName / gender / occupation / race）
    showPersonalExtraFields() {
      const SUPPORTED = ["Malaysia"]; // 后期可新增其他国家
      return SUPPORTED.includes(this.dataForm.nationality);
    },
    // 是否显示地址模块（注册地址 + 服务地址），同时隐藏原 residentialAddress 单行字段
    showAddressModules() {
      const SUPPORTED = ["Malaysia"]; // 后期可新增 "Virgin Islands, British"
      return SUPPORTED.includes(this.dataForm.nationality);
    },
    // 种族选项（raceTypeData 目前仅 Malaysia 有数据）
    raceOptions() {
      return this.byCountryFormatList("raceTypeData", this.dataForm.nationality);
    },
    // Service Address 是否与 Residential Address 相同（勾选=1=Same，未勾选=2=Other）
    isSameAsResidential: {
      get() {
        return this.dataForm.serviceAddressType === 1;
      },
      set(val) {
        this.dataForm.serviceAddressType = val ? 1 : 2;
      },
    },
  },
  methods: {
    // 切换国籍时，证件类型选项会随之变化，清空已选证件类型避免残留无效值
    onNationalityChange() {
      this.dataForm.identificationType = "";
    },
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        const [prefixCopy = "", codeCopy = ""] = data.phone?.split("-") || [];
        this.dataForm = {
          id: data.id,
          nationality: data.nationality,
          fullName: data.fullName,
          formerName: data.formerName || "",
          email: data.email,
          identificationType: data.identificationType,
          identificationNo: data.identificationNo,
          residentialAddress: data.residentialAddress,
          gender: data.gender || "",
          occupation: data.occupation || "",
          race: data.race || "",
          residentialAddressLine1: data.residentialAddressLine1 || "",
          residentialAddressLine2: data.residentialAddressLine2 || "",
          residentialAddressLine3: data.residentialAddressLine3 || "",
          residentialAddressCountry: data.residentialAddressCountry || "",
          residentialAddressCity: data.residentialAddressCity || "",
          residentialAddressState: data.residentialAddressState || "",
          residentialAddressPostalCode: data.residentialAddressPostalCode || "",
          serviceAddressType: data.serviceAddressType || 2,
          serviceAddressLine1: data.serviceAddressLine1 || "",
          serviceAddressLine2: data.serviceAddressLine2 || "",
          serviceAddressLine3: data.serviceAddressLine3 || "",
          serviceAddressCountry: data.serviceAddressCountry || "",
          serviceAddressCity: data.serviceAddressCity || "",
          serviceAddressState: data.serviceAddressState || "",
          serviceAddressPostalCode: data.serviceAddressPostalCode || "",
          phone: {
            prefix: prefixCopy,
            code: codeCopy,
          },
          birthDate: data.birthDate,
          supplierId: data.supplier?.id,
          status: data.status,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async (valid, object) => {
        if (valid) {
          this.submitLoading = true;
          const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
          // Mobile
          const phoneCopy = dataFormCopy.phone;
          dataFormCopy.phone = phoneCopy.prefix + "-" + phoneCopy.code;

          this.$http
            .post(this.dataForm.id ? `/admin/stNomineeDirectorManage/${this.dataForm.id}/update` : `/admin/stNomineeDirectorManage/create`, dataFormCopy)
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        } else {
          validateFormLocation(object, this.$refs["dataForm"]);
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-form-item__content {
    line-height: 35px !important;
  }
}

.address-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f7fa;
  padding: 10px 16px;
  margin-bottom: 12px;
  border-radius: 4px;

  .address-section-title {
    font-weight: 700;
    font-size: 14px;
    color: #303133;
  }

  .same-address-checkbox {
    margin-bottom: 0 !important;

    ::v-deep .el-form-item__content {
      line-height: normal !important;
    }
  }
}
</style>
